import _defineEnumerableProperties from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/defineEnumerableProperties";
import _objectWithoutProperties from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _slicedToArray from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e15) { throw _e15; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e16) { didErr = true; err = _e16; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = Symbol.toPrimitive,
    t = Symbol.for("sxs.composers"),
    n = Object.assign,
    r = Object.create,
    o = Object.defineProperties,
    i = Object.getOwnPropertyDescriptors,
    a = function a(t, r, _a) {
  var _n;

  return n(o(t, i(_a)), (_n = {}, _defineProperty(_n, e, function () {
    return t[r];
  }), _defineProperty(_n, "toString", function toString() {
    return t[r];
  }), _n));
},
    s = function s(e) {
  return e.includes("-") ? e : e.replace(/[A-Z]/g, function (e) {
    return "-" + e.toLowerCase();
  });
},
    l = function l(e, t) {
  return e.reduce(function (e, n) {
    return e.push.apply(e, _toConsumableArray(t.map(function (e) {
      return e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(n) && /&.*&/.test(e) ? ":is(".concat(n, ")") : n) : n + " " + e;
    }))), e;
  }, []);
},
    c = Array.isArray,
    d = Array.from,
    g = Object.prototype.toString,
    p = /\s*,\s*(?![^()]*\))/,
    m = /(-columns|(^|[^e]-)padding|[^t]-spacing|l-align|rows|(^|(^border|[dkmnptx]|le|ne)-)width|^border|tom|[ek]-start|(o|[^e]-du)ration|us|(^|[^tv]-)left|(^|-)top|tance|rgin|e-offset|(er|g|n|t)-block|(^|[^tv]-)right|basis|[gnt]-inline|gap|(^|[^e]-)height|ness|(^|[^p]-)inset|[ek]-end|elay|tline|ve|dent|-rotate|n-rule|(c|ck|d|ne|t)-size)$/,
    h = /([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g,
    f = /\s+(?![^()]*\))/,
    u = function u(e) {
  return function (t) {
    return e.apply(void 0, _toConsumableArray("string" == typeof t ? String(t).split(f) : [t]));
  };
},
    b = /([\d.]+)([^]*)/,
    S = {
  appearance: function appearance(e) {
    return {
      WebkitAppearance: e,
      appearance: e
    };
  },
  backfaceVisibility: function backfaceVisibility(e) {
    return {
      WebkitBackfaceVisibility: e,
      backfaceVisibility: e
    };
  },
  backgroundClip: function backgroundClip(e) {
    return {
      WebkitBackgroundClip: e,
      backgroundClip: e
    };
  },
  boxDecorationBreak: function boxDecorationBreak(e) {
    return {
      WebkitBoxDecorationBreak: e,
      boxDecorationBreak: e
    };
  },
  clipPath: function clipPath(e) {
    return {
      WebkitClipPath: e,
      clipPath: e
    };
  },
  content: function content(e) {
    return {
      content: /^([^]*["'][^]*|[A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : "\"".concat(e, "\"")
    };
  },
  hyphens: function hyphens(e) {
    return {
      WebkitHyphens: e,
      hyphens: e
    };
  },
  maskImage: function maskImage(e) {
    return {
      WebkitMaskImage: e,
      maskImage: e
    };
  },
  tabSize: function tabSize(e) {
    return {
      MozTabSize: e,
      tabSize: e
    };
  },
  userSelect: function userSelect(e) {
    return {
      WebkitUserSelect: e,
      userSelect: e
    };
  },
  marginBlock: u(function (e, t) {
    return {
      marginBlockStart: e,
      marginBlockEnd: t || e
    };
  }),
  marginInline: u(function (e, t) {
    return {
      marginInlineStart: e,
      marginInlineEnd: t || e
    };
  }),
  maxSize: u(function (e, t) {
    return {
      maxBlockSize: e,
      maxInlineSize: t || e
    };
  }),
  minSize: u(function (e, t) {
    return {
      minBlockSize: e,
      minInlineSize: t || e
    };
  }),
  paddingBlock: u(function (e, t) {
    return {
      paddingBlockStart: e,
      paddingBlockEnd: t || e
    };
  }),
  paddingInline: u(function (e, t) {
    return {
      paddingInlineStart: e,
      paddingInlineEnd: t || e
    };
  })
},
    y = function y(e) {
  var t = e.media,
      n = e.prefix,
      r = e.themeMap,
      o = e.utils;
  var i, a, d, f;
  return function (u) {
    return function (e, t) {
      var n = new WeakSet(),
          r = function r(e, o, i, a, d) {
        var m = "";

        e: for (var _h in e) {
          var _f = 64 === _h.charCodeAt(0);

          var _iterator = _createForOfIteratorHelper(_f && c(e[_h]) ? e[_h] : [e[_h]]),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _u = _step.value;

              if (t && (_h !== a || _u !== d)) {
                var _n2 = t(_h, _u, e);

                if (null !== _n2) {
                  m += "object" == typeof _n2 && _n2 ? r(_n2, o, i, _h, _u) : null == _n2 ? "" : _n2;
                  continue e;
                }
              }

              if ("object" == typeof _u && _u && _u.toString === g) {
                n.has(o) && (n.delete(o), m += "}");

                var _e = Object(_h),
                    _t = _f ? o : o.length ? l(o, _h.split(p)) : _h.split(p);

                m += r(_u, _t, _f ? i.concat(_e) : i), n.has(_e) && (n.delete(_e), m += "}"), n.has(_t) && (n.delete(_t), m += "}");
              } else {
                for (var _e2 = 0; _e2 < i.length; ++_e2) {
                  n.has(i[_e2]) || (n.add(i[_e2]), m += i[_e2] + "{");
                }

                o.length && !n.has(o) && (n.add(o), m += o + "{"), m += (_f ? _h + " " : s(_h) + ":") + String(_u) + ";";
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return m;
      };

      return r(e, [], []);
    }(u, function (l, c) {
      var g = l.charCodeAt(0),
          p = 64 === g ? l : /[A-Z]/.test(u = l) ? u : u.replace(/-[^]/g, function (e) {
        return e[1].toUpperCase();
      });
      var u;
      var y = 64 === g ? l : s(l);

      if ("function" == typeof o[l]) {
        if (o[l] != d || c != f) return d = o[l], f = c, d(e)(f);
      } else if ("function" == typeof S[p] && (S[p] != d || c != f)) return d = S[p], f = c, d(f);

      if (f = c, i != p && a != c && /^((min|max)?((Block|Inline)Size|Height|Width)|height|width)$/.test(p)) {
        i = p, a = c;

        var _e3 = String(a).replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, function (e, t, n, r) {
          return t + ("stretch" === n ? "-moz-available".concat(r, ";").concat(y, ":").concat(t, "-webkit-fill-available") : "-moz-fit-content".concat(r, ";").concat(y, ":").concat(t, "fit-content")) + r;
        });

        if (_e3 != c) return _defineProperty({}, l, _e3);
      }

      var k = 64 === g ? (l.slice(1) in t ? "@media " + t[l.slice(1)] : l).replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, function (e, t, n, r, o, i) {
        var a = b.test(t),
            s = .0625 * (a ? -1 : 1),
            _ref2 = a ? [r, t] : [t, r],
            _ref3 = _slicedToArray(_ref2, 2),
            l = _ref3[0],
            c = _ref3[1];

        return "(" + ("=" === n[0] ? "" : ">" === n[0] === a ? "max-" : "min-") + l + ":" + ("=" !== n[0] && 1 === n.length ? c.replace(b, function (e, t, r) {
          return Number(t) + s * (">" === n ? 1 : -1) + r;
        }) : c) + (o ? ") and (" + (">" === o[0] ? "min-" : "max-") + l + ":" + (1 === o.length ? i.replace(b, function (e, t, n) {
          return Number(t) + s * (">" === o ? -1 : 1) + n;
        }) : i) : "") + ")";
      }) : 36 === g ? "--" + n + l.replace(/\$/g, "-") : l;
      var B = "object" == typeof c && c ? c : c && "number" == typeof c && m.test(y) ? String(c) + "px" : String(c).replace(h, function (e, t, o, i, a) {
        return "$" == i == !!o ? e : (t || "--" == i ? "calc(" : "") + "var(" + ("$" === i ? "--" + n + "-" + (a.includes("$") ? "" : p in r ? r[p] + "-" : "") + a.replace(/\$/g, "-") : i + a) + ")" + (t || "--" == i ? "*" + (t || "") + (o || "1") + ")" : "");
      });
      return c != B || y != k ? _defineProperty({}, k, B) : null;
    });
  };
},
    k = Reflect.ownKeys,
    B = /*#__PURE__*/function (_Set) {
  _inherits(B, _Set);

  var _super = _createSuper(B);

  function B() {
    _classCallCheck(this, B);

    return _super.apply(this, arguments);
  }

  _createClass(B, [{
    key: "toString",
    value: function toString() {
      return d(this).join("");
    }
  }, {
    key: "hasChanged",
    get: function get() {
      var _this = this;

      var e = this.size;
      return function () {
        return e < _this.size;
      };
    }
  }]);

  return B;
}( /*#__PURE__*/_wrapNativeSuper(Set)),
    w = B;

B.prototype[e] = B.prototype.toString;

var x = "colors",
    I = "sizes",
    C = "space",
    $ = {
  gap: C,
  gridGap: C,
  columnGap: C,
  gridColumnGap: C,
  rowGap: C,
  gridRowGap: C,
  inset: C,
  insetBlock: C,
  insetBlockEnd: C,
  insetBlockStart: C,
  insetInline: C,
  insetInlineEnd: C,
  insetInlineStart: C,
  margin: C,
  marginTop: C,
  marginRight: C,
  marginBottom: C,
  marginLeft: C,
  marginBlock: C,
  marginBlockEnd: C,
  marginBlockStart: C,
  marginInline: C,
  marginInlineEnd: C,
  marginInlineStart: C,
  padding: C,
  paddingTop: C,
  paddingRight: C,
  paddingBottom: C,
  paddingLeft: C,
  paddingBlock: C,
  paddingBlockEnd: C,
  paddingBlockStart: C,
  paddingInline: C,
  paddingInlineEnd: C,
  paddingInlineStart: C,
  top: C,
  right: C,
  bottom: C,
  left: C,
  scrollMargin: C,
  scrollMarginTop: C,
  scrollMarginRight: C,
  scrollMarginBottom: C,
  scrollMarginLeft: C,
  scrollMarginX: C,
  scrollMarginY: C,
  scrollMarginBlock: C,
  scrollMarginBlockEnd: C,
  scrollMarginBlockStart: C,
  scrollMarginInline: C,
  scrollMarginInlineEnd: C,
  scrollMarginInlineStart: C,
  scrollPadding: C,
  scrollPaddingTop: C,
  scrollPaddingRight: C,
  scrollPaddingBottom: C,
  scrollPaddingLeft: C,
  scrollPaddingX: C,
  scrollPaddingY: C,
  scrollPaddingBlock: C,
  scrollPaddingBlockEnd: C,
  scrollPaddingBlockStart: C,
  scrollPaddingInline: C,
  scrollPaddingInlineEnd: C,
  scrollPaddingInlineStart: C,
  fontSize: "fontSizes",
  background: x,
  backgroundColor: x,
  backgroundImage: x,
  border: x,
  borderBlock: x,
  borderBlockEnd: x,
  borderBlockStart: x,
  borderBottom: x,
  borderBottomColor: x,
  borderColor: x,
  borderInline: x,
  borderInlineEnd: x,
  borderInlineStart: x,
  borderLeft: x,
  borderLeftColor: x,
  borderRight: x,
  borderRightColor: x,
  borderTop: x,
  borderTopColor: x,
  caretColor: x,
  color: x,
  columnRuleColor: x,
  fill: x,
  outline: x,
  outlineColor: x,
  stroke: x,
  textDecorationColor: x,
  fontFamily: "fonts",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  blockSize: I,
  minBlockSize: I,
  maxBlockSize: I,
  inlineSize: I,
  minInlineSize: I,
  maxInlineSize: I,
  width: I,
  minWidth: I,
  maxWidth: I,
  height: I,
  minHeight: I,
  maxHeight: I,
  flexBasis: I,
  gridTemplateColumns: I,
  gridTemplateRows: I,
  borderWidth: "borderWidths",
  borderTopWidth: "borderWidths",
  borderRightWidth: "borderWidths",
  borderBottomWidth: "borderWidths",
  borderLeftWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderTopStyle: "borderStyles",
  borderRightStyle: "borderStyles",
  borderBottomStyle: "borderStyles",
  borderLeftStyle: "borderStyles",
  borderRadius: "radii",
  borderTopLeftRadius: "radii",
  borderTopRightRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  boxShadow: "shadows",
  textShadow: "shadows",
  transition: "transitions",
  zIndex: "zIndices"
},
    j = function j(e, t) {
  for (var n = JSON.stringify(t), r = n.length, o = 9; r;) {
    o = Math.imul(o ^ n.charCodeAt(--r), Math.pow(9, 9));
  }

  return e + (o ^ o >>> 9).toString(36).slice(-5);
},
    z = function z(e) {
  return e ? "-" + e : "";
},
    v = /*#__PURE__*/function () {
  function v(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

    _classCallCheck(this, v);

    this.value = e, this.token = t, this.scale = n, this.prefix = r;
  }

  _createClass(v, [{
    key: "computedValue",
    get: function get() {
      return "var(" + this.variable + ")";
    }
  }, {
    key: "variable",
    get: function get() {
      return "-" + z(this.prefix) + z(this.scale) + "-" + this.token;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.computedValue;
    }
  }]);

  return v;
}(),
    M = /*#__PURE__*/function (_Array) {
  _inherits(M, _Array);

  var _super2 = _createSuper(M);

  function M() {
    _classCallCheck(this, M);

    return _super2.apply(this, arguments);
  }

  _createClass(M, [{
    key: "toString",
    value: function toString() {
      return this.join("");
    }
  }, {
    key: "hasChanged",
    get: function get() {
      var _this2 = this;

      var e = String(this);
      return function () {
        return e !== String(_this2);
      };
    }
  }]);

  return M;
}( /*#__PURE__*/_wrapNativeSuper(Array)),
    W = M;

M.prototype[e] = M.prototype.toString;

var E = function E(e) {
  var t,
      r,
      o,
      i,
      a,
      s = !1;
  var l = "append" === e.insertionMethod ? "append" : "prepend";
  return function (e) {
    "object" == typeof document && (t || (t = document.head || document.documentElement), r || (r = document.getElementById("stitches") || n(document.createElement("style"), {
      id: "stitches",
      textContent: e
    })), o || (o = r.firstChild || new Text(), s = !o.data), i || (i = r.insertBefore(new Text(), o)), r.isConnected || t[l](r), i.data = e, !s && e && (clearTimeout(a), a = setTimeout(function () {
      o.remove(), s = !0;
    }, 250)));
  };
},
    P = function P(e) {
  e = "object" == typeof e && e || {};
  var o = {};
  o.media = n({
    initial: "all"
  }, e.media), o.theme = "object" == typeof e.theme && e.theme || {}, o.themeMap = "object" == typeof e.themeMap && e.themeMap || $, o.utils = "object" == typeof e.utils && e.utils || {};
  var i = new Set(e.passthru ? [].concat(_toConsumableArray(e.passthru), ["as", "className"]) : ["as", "className"]),
      s = o.prefix = e.prefix || "sx";
  o.insertionMethod = e.insertionMethod || "prepend";
  var l = ("function" == typeof o.insertionMethod ? o.insertionMethod : E)(o),
      c = "03kze",
      g = y(o),
      p = new w(),
      m = new w(),
      h = new w(),
      f = new w(),
      u = new w([p, m, h, f]);
  var b = "";

  var S = function S() {
    var e = d(u).join("");
    b !== e && l(b = e);
  },
      B = function B(e, t) {
    t = "object" == typeof e && e || Object(t);
    var n = (e = (e = "string" == typeof e ? e : "") || j(s, t)).replace(/^\w/, ".$&"),
        o = a(r(null), "className", {
      className: e,
      selector: n
    }),
        i = {},
        l = i[n] = {};

    var _loop = function _loop(_e4) {
      o[_e4] = r(null);

      for (var _n3 in t[_e4]) {
        var _r = String(t[_e4][_n3]);

        _r.includes("$") && (_r = _r.replace(/\$([$\w-]+)/g, function (t, n) {
          return n.includes("$") ? t : "$" + _e4 + t;
        }));

        var _i = o[_e4][_n3] = new v(_r, _n3, _e4, s);

        l[_i.variable] = _i.value;
      }
    };

    for (var _e4 in t) {
      _loop(_e4);
    }

    var d = e === s + c ? "" : g(i);
    return a(o, "className", {
      get className() {
        var t = m.hasChanged;
        return m.add(d), t() && S(), e;
      },

      selector: n
    });
  },
      x = function x(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var n = new w(),
        o = new w();

    for (var _t2 in e) {
      if (e[_t2] !== Object(e[_t2]) || k(e[_t2]).length) {
        var _r2 = g(_defineProperty({}, _t2, e[_t2]));

        ("@import" === _t2 ? n : o).add(_r2);
      }
    }

    var i = a(r(null), "name", {
      name: t
    }),
        s = a(function () {
      var e = p.hasChanged,
          t = h.hasChanged;
      return n.forEach(function (e) {
        p.add(e);
      }), o.forEach(function (e) {
        h.add(e);
      }), (e() || t()) && S(), i;
    }, "name", {
      get name() {
        return String(s());
      }

    });
    return s;
  },
      I = function I(e) {
    var t = new w(),
        n = new W(),
        o = new w(),
        i = new w([t, n, o]);

    var a = e.variants,
        l = e.compoundVariants,
        d = e.defaultVariants,
        p = _objectWithoutProperties(e, ["variants", "compoundVariants", "defaultVariants"]);

    d = Object(d);
    var m = j(s, e),
        h = "." + m,
        u = m === s + c ? "" : g(_defineProperty({}, h, p));
    f.add(i);
    var b = r(null),
        S = [],
        y = [];

    for (var _e5 in a) {
      for (var _t3 in a[_e5]) {
        var _y$push;

        var _n4 = a[_e5][_t3];
        y.push((_y$push = {}, _defineProperty(_y$push, _e5, _t3), _defineProperty(_y$push, "css", _n4), _y$push));
      }
    }

    y.push.apply(y, _toConsumableArray(l || []));

    var _loop2 = function _loop2(_e6) {
      var _y$_e = y[_e6],
          t = _y$_e.css,
          o = _objectWithoutProperties(_y$_e, ["css"]),
          i = k(o),
          a = i.length;

      var _iterator3 = _createForOfIteratorHelper(i),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _e10 = _step3.value;
          b[_e10] = b[_e10] || r(null), b[_e10][o[_e10]] = !0;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var s = function s(e, r) {
        e = _objectSpread({}, e);

        for (var _t5 in r) {
          void 0 !== e[_t5] || Object(b[_t5])[e[_t5]] || (e[_t5] = r[_t5]);
        }

        var s = new Set();

        if (i.length && i.every(function (t) {
          var n = e[t],
              r = String(o[t]);
          if (r === String(n)) return !0;
          if (n === Object(n)) for (var _e7 in n) {
            if (r == String(n[_e7]) && 64 === _e7.charCodeAt(0)) return s.add(_e7), !0;
          }
        })) {
          var _e8 = Object(t);

          var _iterator4 = _createForOfIteratorHelper(s),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _t6 = _step4.value;
              _e8 = _defineProperty({}, _t6, _e8);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var _r3 = m + j("", _e8) + "--" + (1 === a ? i[0] + "-" + o[i[0]] : "c" + a),
              _l = g(_defineProperty({}, "." + _r3, _e8));

          return (n[a - 1] || (n[a - 1] = new w())).add(_l), _r3;
        }
      };

      S.push(s);
    };

    for (var _e6 in y) {
      _loop2(_e6);
    }

    return {
      apply: function apply(e, r, o) {
        var a = t.hasChanged,
            s = n.hasChanged;

        if (t.add(u), e) {
          r.add(m);

          var _iterator2 = _createForOfIteratorHelper(S),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _t4 = _step2.value;

              var _n5 = _t4(e, o);

              _n5 && r.add(_n5);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        if (a() || s()) return f.add(i), !0;
      },
      inline: function inline(e, t) {
        var n = j("-", e),
            r = m === "-" + n ? "" : g(_defineProperty({}, h + n, e));
        t.add(m + n);
        var i = o.hasChanged;
        return r && o.add(r), i();
      },
      className: m,
      defaultVariants: d,
      selector: h,
      variantProps: b
    };
  },
      C = B(":root", o.theme),
      z = a({
    css: function css() {
      var _className, _a3, _mutatorMap2;

      var o,
          s = [],
          l = r(null);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      for (var _i2 = 0, _e11 = e; _i2 < _e11.length; _i2++) {
        var _r4 = _e11[_i2];
        if (_r4 === Object(_r4)) if (t in _r4) {
          var _iterator5 = _createForOfIteratorHelper(_r4[t]),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e12 = _step5.value;
              s.push(_e12), n(l, _e12.defaultVariants);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        } else s.push(o = I(_r4)), n(l, o.defaultVariants);
      }

      return o || s.push(o = I({})), a(function (e) {
        var _a2, _mutatorMap;

        var _Object = Object(e),
            n = _Object.css,
            c = _objectWithoutProperties(_Object, ["css"]),
            g = new Set();

        var p,
            m = !1;

        var _iterator6 = _createForOfIteratorHelper(s),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _e14 = _step6.value;
            m = _e14.apply(c, g, l) || m;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        n === Object(n) && (p = o.inline(n, g)), (m || p) && S();

        for (var _e13 in o.variantProps) {
          i.has(_e13) || delete c[_e13];
        }

        "string" == typeof c.className && c.className.split(/\s+/).forEach(g.add, g);
        var h = d(g);
        return c.className = h.join(" "), a(r(null), "className", (_a2 = {}, _mutatorMap = {}, _mutatorMap[t] = _mutatorMap[t] || {}, _mutatorMap[t].get = function () {
          return s;
        }, _defineProperty(_a2, "className", c.className), _defineProperty(_a2, "props", c), _defineProperty(_a2, "selector", o.selector), _defineEnumerableProperties(_a2, _mutatorMap), _a2));
      }, "className", (_a3 = {}, _mutatorMap2 = {}, _mutatorMap2[t] = _mutatorMap2[t] || {}, _mutatorMap2[t].get = function () {
        return s;
      }, _className = "className", _mutatorMap2[_className] = _mutatorMap2[_className] || {}, _mutatorMap2[_className].get = function () {
        return o.apply() && S(), o.className;
      }, _defineProperty(_a3, "selector", o.selector), _defineEnumerableProperties(_a3, _mutatorMap2), _a3));
    },
    config: o,
    global: x,
    keyframes: function keyframes(e) {
      var t = j(s, e);
      return x(_defineProperty({}, "@keyframes " + t, e), t);
    },
    prefix: s,
    reset: function reset() {
      return p.clear(), m.clear(), h.clear(), f.clear(), C.className, z;
    },
    theme: n(B, C),

    get cssText() {
      return b;
    },

    getCssString: function getCssString() {
      return b;
    }
  }, "cssText", {});

  return z;
},
    N = Symbol.for("react.element"),
    T = Symbol.for("react.forward_ref"),
    O = function O(e) {
  var r = P(e);
  return n(r, {
    styled: function styled() {
      var _className2, _selector, _Object$setPrototypeO, _mutatorMap3;

      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }

      var n = e.map(function (e) {
        return Object(e).type ? e.type : e;
      }).find(function (e) {
        return e;
      }) || "span",
          o = r.css.apply(r, _toConsumableArray(e.filter(function (e) {
        return t in Object(e) || e && "object" == typeof e && !e.$$typeof;
      })));
      return Object.setPrototypeOf((_Object$setPrototypeO = {
        render: function render(e, t) {
          var _o = o(e),
              _o$props = _o.props,
              _o$props$as = _o$props.as,
              r = _o$props$as === void 0 ? n : _o$props$as,
              i = _objectWithoutProperties(_o$props, ["as"]),
              a = _objectWithoutProperties(_o, ["props"]);

          return {
            constructor: void 0,
            $$typeof: N,
            props: i,
            ref: t,
            type: r,
            __v: 0
          };
        },
        $$typeof: T
      }, _defineProperty(_Object$setPrototypeO, t, o[t]), _defineProperty(_Object$setPrototypeO, Symbol.toPrimitive, function () {
        return o.selector;
      }), _defineProperty(_Object$setPrototypeO, "toString", function toString() {
        return o.selector;
      }), _className2 = "className", _mutatorMap3 = {}, _mutatorMap3[_className2] = _mutatorMap3[_className2] || {}, _mutatorMap3[_className2].get = function () {
        return o.className;
      }, _selector = "selector", _mutatorMap3[_selector] = _mutatorMap3[_selector] || {}, _mutatorMap3[_selector].get = function () {
        return o.selector;
      }, _defineProperty(_Object$setPrototypeO, "type", n), _defineEnumerableProperties(_Object$setPrototypeO, _mutatorMap3), _Object$setPrototypeO), Object(n));
    }
  });
},
    R = function R() {
  return R.config || (R.config = O());
},
    A = function A() {
  var _R;

  return (_R = R()).css.apply(_R, arguments);
},
    L = function L() {
  var _R2;

  return (_R2 = R()).global.apply(_R2, arguments);
},
    V = function V() {
  var _R3;

  return (_R3 = R()).keyframes.apply(_R3, arguments);
},
    H = function H() {
  var _R4;

  return (_R4 = R()).styled.apply(_R4, arguments);
};

export { O as createCss, A as css, O as default, $ as defaultThemeMap, L as global, V as keyframes, H as styled }; //# sourceMappingUrl=index.map